var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"4rem","margin-right":"4rem"}},[_c('Checkbox',{attrs:{"label":"Checkbox test","name":"RequiredName","value":true,"passedProps":{ onChange: function (e) { return _vm.handleChanged(e); }}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }